import React from 'react'
import axios from 'axios'
import { browserHistory } from 'react-router'
import SchedulePanel from './SchedulePanel'
import ScheduleItem from './ScheduleItem'
import { LoadMore, Button } from 'react-weui'
import { Page } from '../../components'
import { WKInfiniteScroll, WKVisible, WkPanel } from '../../components/wk'
import { TimeStream } from '../../utils'
import emptyImg from '../../images/schedule/schedule-empty.png'
import clockImg from '../../images/question.png'
import tipImg from '../../images/schedule/my-list-tip.png'


class ScheduleMyListPage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            schedules: null,
            isPending: true,
            offset: 0,
            hasMore: true,
        }
    }
    componentDidMount () {
        document.title = '我的打卡'
        this.fetchSchedules()
    }
    fetchSchedules () {
        this.setState({ isPending: true })
        axios.get(`/api/schedule/my_schedules`, {
            params: {
                offset: this.state.offset,
            }
        })
            .then(res => {
                this.setState({
                    schedules: (this.state.schedules || []).concat(res.data.data.schedules),
                    isPending: false,
                    offset: res.data.data.next_offset,
                    hasMore: res.data.data.has_more,
                })
            })
    }
    getBtnInfo (item) {
        if (item.schedule.process === 'not_start') {
            return {
                text: '已参与',
                isDisable: true,
            }
        }
        if (item.schedule.process === 'close') {
            return {
                text: '已结束',
                isDisable: true,
            }
        }
        if (item.schedule.process === 'starting') {
            if (item.is_signin_today) {
                return {
                    text: '已打卡',
                    isDisable: true,
                }
            } else {
                return {
                    text: '打卡',
                    isDisable: false,
                }
            }

        }
    }
    onClickMore () {
        location.assign('/')
    }
    onClickStart () {
        location.assign('https://mp.weixin.qq.com/s/gShGSJQAltIo-td6pzASNg ')
    }
    render() {
        const schedules = this.state.schedules
        return (
            <Page>
                <div className="wk-inner-page schedule-my-list">
                    <WKVisible create={schedules && schedules.length === 0} className='empty-wrap'>
                        <div className="content">
                            <img src={emptyImg} alt=""/>
                            <div className="text">
                                <p>你还尚未创建打卡</p>
                            </div>
                            <Button type='primary' onClick={e => this.onClickMore()}>发现更多</Button>
                            {/*<Button type='default' onClick={e => this.onClickStart()}>发起打卡</Button>*/}
                        </div>
                    </WKVisible>
                    <WKVisible create={schedules && schedules.length > 0}>
                        <WkPanel
                            title={`打卡`}
                            isNoPadding={true}
                            tip={
                                <img style={{width: '79px', marginTop: '3px'}} src={tipImg} onClick={e => location.assign('/schedule/my/setting')} />
                            }
                        >
                            {
                                schedules && schedules.map(item => (
                                    <ScheduleItem
                                        isJoin={true}
                                        item={item}
                                        key={item.schedule.id}
                                        id={item.schedule.id}
                                        banner={item.schedule.banner}
                                        title={item.schedule.name}
                                        signinCount={item.schedule.current_day}
                                        joinCount={item.participate_count}
                                        time={`${TimeStream(item.schedule.beg_timestamp, 'YMD')} 至 ${TimeStream(item.schedule.end_timestamp, 'YMD')}`}
                                        btnText={this.getBtnInfo(item).text}
                                        isBtnDisabled={this.getBtnInfo(item).isDisable}
                                        isHideBtn={true}
                                    />
                                ))
                            }
                        </WkPanel>
                    </WKVisible>
                    <WKInfiniteScroll
                        onTouchBottom={() => this.fetchSchedules()}
                        isStop={this.state.isPending}
                        isKill={!this.state.hasMore}
                        isShowLoading={true}
                    />
                </div>
            </Page>
        )
    }
}

export default ScheduleMyListPage



// WEBPACK FOOTER //
// ./src/pages/schedule/ScheduleMyListPage.js